export const SIDEBAR_SECTIONS = [
  {
    label: "OVERVIEW",
    items: [
      {
        title: "Dashboard",
        path: "/user-dashboard",
        icon: "▦",
      },
      {
        title: "My Card",
        path: "/dashboard/my-card",
        icon: "🎴",
      },
    ],
  },
  {
    label: "SELL",
    items: [
      {
        title: "Orders",
        path: "/dashboard/open-orders",
        icon: "⬒",
      },
      {
        title: "Quotes",
        path: "/dashboard/quotes",
        icon: "❝",
      },
      {
        title: "Sell",
        path: "/dashboard/sell",
        icon: "⚡",
      },
      {
        title: "Ship Direct",
        path: "/dashboard/member-ship-direct",
        icon: "➤",
      },
    ],
  },
  {
    label: "TRACK & MONEY",
    items: [
      {
        title: "Shipments",
        path: "/dashboard/shipment",
        icon: "📦",
        children: [
          {
            title: "Shipping & Tracking",
            path: "/dashboard/shipment",
          },
          {
            title: "Payouts",
            path: "/dashboard/shipment/member-payouts",
          },
        ],
      },
      {
        title: "Wallet & Gift Cards",
        path: "/dashboard/wallet",
        icon: "👛",
        children: [
          {
            title: "Wallet",
            path: "/dashboard/wallet",
          },
          {
            title: "Gift Cards",
            path: "/dashboard/wallet/gift-cards",
          },
          {
            title: "Payment Methods",
            path: "/dashboard/wallet/payment-methods",
          },
        ],
      },
      {
        title: "Condition & Damages",
        path: "/dashboard/condition-damages",
        icon: "🛡️",
      },
    ],
  },
  {
    label: "SUPPORT",
    items: [
      {
        title: "Help & Support",
        path: "/dashboard/help-support",
        icon: "?",
      },
      {
        title: "Policies",
        path: "/dashboard/t&c",
        icon: "§",
        children: [
          {
            title: "Terms & Conditions",
            path: "/dashboard/t&c",
          },
          {
            title: "Privacy Policy",
            path: "/dashboard/privacy-policy",
          },
        ],
      },
    ],
  },
];
